import React from 'react';
import './Banner.css';

import { Button, Heading } from '../../../components';



const Banner = () => {

  return (
    <section className="banner">
      <div className='content'>

        <Heading title={"Find the Perfect Door And Window for Your Home"} subTitle={"Secure Your Home Entrance"} linear sideHeading />
        <Button link={"Get-Quote"} title={"Get Quote"} />

      </div>
    </section>
  );

};

export default Banner;